import { getClassNames } from "@/shared/utils";
import styles from "./styles.module.scss";

type Props = {
  title: string;
  className?: string;
};

export const SettingsSectionTitle = ({ title, className }: Props) => {
  return (
    <div className={getClassNames(styles.title, className)}>
      <p>{title}</p>
    </div>
  );
};
